import api from "../../../utilidades/interceptor";
import Swal from "sweetalert2";
const urlApi = process.env.REACT_APP_API_KEY



export const getClientsCatalog = async () => {
    try {

        const result = await api.get(`${urlApi}/comercial/getVendorCatalog`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};
export const getVendorCatalogById = async (id_proveedor) => {
    try {

        const result = await api.get(`${urlApi}/comercial/getVendorCatalogById?id_proveedor=${id_proveedor}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};
export const addVendorCatalog = async (vendorData) => {
    try {

        const result = await api.post(`${urlApi}/comercial/addVendorCatalog`, vendorData);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};
export const updateVendorCatalogService = async (vendorData) => {
    try {

        const result = await api.patch(`${urlApi}/comercial/updateVendorCatalog`, vendorData);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};
export const getVendorCategory = async () => {
    try {

        const result = await api.get(`${urlApi}/comercial/getVendorCategory`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};
export const getCiudad = async () => {
    try {

        const result = await api.get(`${urlApi}/comercial/getCity`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
};
